(function(angular){
	'use strict';
	
	angular.module('hbiModule', [
		'affixRevealModule',
		'coreModule',
		'homePriceChartModule',
		'waitlistModule'
	]);

})(window.angular);